export var SelectMode = /*#__PURE__*/ function(SelectMode) {
    SelectMode["oneByOne"] = "one-by-one";
    SelectMode["onlyOne"] = "only-one";
    SelectMode["many"] = "many";
    return SelectMode;
}({});

//# sourceMappingURL=types.js.map